// src/hooks/useSalesMetrics.ts

import { useState, useEffect } from 'react';
import { DashboardService } from '../services/api/dashboardService';

export function useSalesMetrics(sucursalId: number) {
  const [metrics, setMetrics] = useState({
    totalSales: 0,
    targetPercentage: 0,
    dailyTotal: 0,
    previousWeekTotal: 0,
    previousMonthTotal: 0,
    target: 0,
    isLoading: true,
    error: null as string | null,
    // ✅ Nuevos campos
    dailyReturns: 0,
    dailyGrossTotal: 0,
  });

  useEffect(() => {
    let isSubscribed = true;

    const fetchMetrics = async () => {
      try {
        const data = await DashboardService.fetchSalesMetrics(sucursalId);
        if (isSubscribed) {
          setMetrics(data);
        }
      } catch (error) {
        if (isSubscribed) {
          setMetrics((prev) => ({
            ...prev,
            isLoading: false,
            error: 'Error al cargar los datos',
          }));
        }
      }
    };

    fetchMetrics();

    // ✅ Actualizar cada 2 minutos
    const interval = setInterval(fetchMetrics, 2 * 60 * 1000);

    return () => {
      isSubscribed = false;
      clearInterval(interval);
    };
  }, [sucursalId]);

  return metrics;
}